import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=c4390c36&scoped=true"
import script from "./SortIcon.vue?vue&type=script&lang=js"
export * from "./SortIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4390c36",
  null
  
)

export default component.exports